/** Hrvatska pošta (HR) — tekstovi na success stranici nakon captcha. */
export const hrPostaSuccessCopy = {
  pageTitle: 'Potvrda o plaćanju od kupca',
  statusTitle: 'Vaša roba je izdana!',
  statusSub: 'Kupac je već platio narudžbu.',
  deliverySection: 'Detalji isporuke',
  addressLabel: 'Adresa isporuke',
  lastName: 'Prezime',
  firstName: 'Ime',
  legal1:
    'Nakon primitka gotovine, pošaljite robu kupcu prema navedenim podacima ili prenesite robu kuriru koji će vas nazvati u roku od 12 sati.',
  legal2:
    'Nakon isporuke robe, navedite kupcu broj dostave! Roba mora biti isporučena u roku od 3 dana nakon primitka sredstava.',
  cta: 'DOBITI NOVAC',
  secure: 'Plaćanje je sigurno',
  disclaimer:
    'Klikom na gumb \'DOBITI NOVAC\' prihvaćate Uvjeti korištenja online - usluga \'Sigurna ponuda\'.',
  loading: 'Učitavanje…',
};
